import { createSlice } from "@reduxjs/toolkit";
import { UserRepository } from "../domain";
import { ServiceLocater, Services } from "../service-locater";

type AuthState = {
  isAuthenticated: "initial" | "authenticated" | "unAuthenticated";
};

const initialState: AuthState = {
  isAuthenticated: "initial",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    checkAuthentication(state) {
      const res = ServiceLocater.get<UserRepository>(
        Services.UserRepository
      ).isLoggedIn();
      if (res) {
        state.isAuthenticated = "authenticated";
      } else {
        state.isAuthenticated = "unAuthenticated";
      }
    },
    logOut(state) {
      state.isAuthenticated = "unAuthenticated";
      ServiceLocater.get<UserRepository>(Services.UserRepository).logOut();
    },
  },
});

export const { checkAuthentication, logOut } = authSlice.actions;
export default authSlice.reducer;
